import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-cefa7b28"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  "class": "mainMenu"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "mainMenu__title"
  }, "Settings", -1);
});
var _hoisted_3 = {
  "class": "userEmail"
};
var _hoisted_4 = {
  "class": "userEmail__color"
};
var _hoisted_5 = {
  key: 0,
  "class": "membership"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "membership-label-inside"
  }, "Pro", -1);
});
var _hoisted_7 = {
  key: 1,
  "class": "membership"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "membership-label-inside"
  }, "Core Membership", -1);
});
var _hoisted_9 = {
  key: 2,
  "class": "membership"
};
var _hoisted_10 = {
  "class": "mainMenu__slot"
};
var _hoisted_11 = {
  "class": "TokenBalance__container"
};
var _hoisted_12 = {
  "class": "TokenBalance__count"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "TokenBalance__label"
  }, "Token Balance", -1);
});
var _hoisted_14 = {
  key: 0,
  "class": "TokenBalance__error"
};
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "title"
  }, "Active Purchases", -1);
});
var _hoisted_16 = {
  "class": "purchases__container"
};
var _hoisted_17 = {
  "class": "purchases__icon-container"
};
var _hoisted_18 = {
  "class": "purchases__title"
};
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "title"
  }, "Purchase History", -1);
});
var _hoisted_20 = {
  "class": "purchases__container"
};
var _hoisted_21 = {
  "class": "purchases__icon-container"
};
var _hoisted_22 = {
  "class": "purchases__title"
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "mainMenu__slot"
  }, [/*#__PURE__*/_createElementVNode("div", {
    "data-mesh-id": "comp-kq5bdzq3inlineContent",
    "data-testid": "inline-content",
    "class": ""
  }, [/*#__PURE__*/_createElementVNode("div", {
    "data-mesh-id": "comp-kq5bdzq3inlineContent-gridContainer",
    "data-testid": "mesh-container-content"
  }, [/*#__PURE__*/_createElementVNode("div", {
    id: "comp-kq5bckd3",
    "class": "KcpHeO tz5f0K comp-kq5bckd3 wixui-rich-text",
    "data-testid": "richTextElement"
  }, [/*#__PURE__*/_createElementVNode("p", {
    "class": "font_6 wixui-rich-text__text",
    style: {
      "line-height": "normal",
      "font-size": "21px"
    }
  }, [/*#__PURE__*/_createElementVNode("span", {
    style: {
      "font-weight": "bold"
    },
    "class": "wixui-rich-text__text"
  }, [/*#__PURE__*/_createElementVNode("span", {
    style: {
      "letter-spacing": "normal"
    },
    "class": "wixui-rich-text__text"
  })])])]), /*#__PURE__*/_createElementVNode("h4", null, [/*#__PURE__*/_createElementVNode("b", null, "Recommended"), /*#__PURE__*/_createTextVNode(" Get Support, give feedback or sugguestions by "), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("a", {
    href: "https://discord.gg/H5qe6yMPkP",
    target: "_system"
  }, "Joining us On Discord!")])]), /*#__PURE__*/_createElementVNode("h4", null, [/*#__PURE__*/_createTextVNode("Connect On Social Media "), /*#__PURE__*/_createElementVNode("div", null, "(Not Recommended For Support)")]), /*#__PURE__*/_createElementVNode("div", {
    id: "comp-kq5bcqwv",
    "class": "KcpHeO tz5f0K comp-kq5bcqwv wixui-rich-text",
    "data-testid": "richTextElement"
  }, [/*#__PURE__*/_createElementVNode("p", {
    "class": "font_9 wixui-rich-text__text",
    style: {
      "line-height": "2em",
      "font-size": "16px"
    }
  }, [/*#__PURE__*/_createElementVNode("span", {
    style: {
      "font-weight": "normal"
    },
    "class": "wixui-rich-text__text"
  }, [/*#__PURE__*/_createElementVNode("a", {
    href: "https://www.tiktok.com/@aivitar",
    target: "_system",
    rel: "noreferrer noopener",
    "class": "wixui-rich-text__text"
  }, "TikTok")])]), /*#__PURE__*/_createElementVNode("p", {
    "class": "font_9 wixui-rich-text__text",
    style: {
      "line-height": "2em",
      "font-size": "16px"
    }
  }, [/*#__PURE__*/_createElementVNode("a", {
    href: "https://www.facebook.com/profile.php?id=100092687227414",
    target: "_system",
    rel: "noreferrer noopener",
    "class": "wixui-rich-text__text"
  }, [/*#__PURE__*/_createElementVNode("span", {
    style: {
      "letter-spacing": "normal"
    },
    "class": "wixui-rich-text__text"
  }, [/*#__PURE__*/_createElementVNode("span", {
    "class": "color_14 wixui-rich-text__text"
  }, "Facebook")])])]), /*#__PURE__*/_createElementVNode("p", {
    "class": "font_9 wixui-rich-text__text",
    style: {
      "line-height": "2em",
      "font-size": "16px"
    }
  }, [/*#__PURE__*/_createElementVNode("a", {
    href: "https://www.youtube.com/@aivitar",
    target: "_system",
    rel: "noreferrer noopener",
    "class": "wixui-rich-text__text"
  }, [/*#__PURE__*/_createElementVNode("span", {
    style: {
      "letter-spacing": "normal"
    },
    "class": "wixui-rich-text__text"
  }, [/*#__PURE__*/_createElementVNode("span", {
    "class": "color_14 wixui-rich-text__text"
  }, "YouTube")])])]), /*#__PURE__*/_createElementVNode("p", {
    "class": "font_9 wixui-rich-text__text",
    style: {
      "line-height": "2em",
      "font-size": "16px"
    }
  }, [/*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/_aivitar",
    target: "_system",
    rel: "noreferrer noopener",
    "class": "wixui-rich-text__text"
  }, [/*#__PURE__*/_createElementVNode("span", {
    style: {
      "letter-spacing": "normal"
    },
    "class": "wixui-rich-text__text"
  }, [/*#__PURE__*/_createElementVNode("span", {
    "class": "color_14 wixui-rich-text__text"
  }, "Twitter")])])]), /*#__PURE__*/_createElementVNode("p", {
    "class": "font_9 wixui-rich-text__text",
    style: {
      "line-height": "2em",
      "font-size": "16px"
    }
  }, [/*#__PURE__*/_createElementVNode("span", {
    style: {
      "letter-spacing": "normal"
    },
    "class": "wixui-rich-text__text"
  }, [/*#__PURE__*/_createElementVNode("span", {
    "class": "color_14 wixui-rich-text__text"
  }, [/*#__PURE__*/_createElementVNode("span", {
    style: {
      "text-decoration": "underline"
    },
    "class": "wixui-rich-text__text"
  }, [/*#__PURE__*/_createElementVNode("a", {
    href: "https://www.instagram.com/_aivitar/",
    target: "_system",
    rel: "noreferrer noopener",
    "class": "wixui-rich-text__text"
  }, "Instagram")])])])])])])]), /*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin-top": "30px"
    }
  }, [/*#__PURE__*/_createTextVNode(" Or email us at "), /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:support@aivitar.com"
  }, "support@aivitar.com")])], -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_mainMenuNavigationItem = _resolveComponent("mainMenuNavigationItem");
  var _component_VoiceSelector = _resolveComponent("VoiceSelector");
  var _component_communityGuidelines = _resolveComponent("communityGuidelines");
  var _component_termsOfService = _resolveComponent("termsOfService");
  var _component_privacyPolicy = _resolveComponent("privacyPolicy");
  var _component_releaseNotes = _resolveComponent("releaseNotes");
  return _ctx.$store.state.ShowMainMenu == true ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_font_awesome_icon, {
    "class": "closeIcon",
    icon: "window-close",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.closeSidebar();
    })
  }), _createElementVNode("div", _hoisted_3, [_createTextVNode(" Logged In As: "), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$store.state.userEmail), 1)]), _ctx.$store.state.proMembership ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createTextVNode(" Subscription "), _hoisted_6])) : _createCommentVNode("", true), _ctx.$store.state.basicMembership ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createTextVNode(" Subscription "), _hoisted_8])) : _createCommentVNode("", true), !_ctx.$store.state.proMembership && !_ctx.$store.state.basicMembership ? (_openBlock(), _createElementBlock("div", _hoisted_9, " No Active Subscription ")) : _createCommentVNode("", true), _ctx.showMainMenu && !_ctx.$store.state.ShowAvatarSettings ? (_openBlock(), _createBlock(_component_mainMenuNavigationItem, {
    key: 3,
    breadcrumbs: _ctx.mainMenu.breadcrumbs,
    menuItems: _ctx.mainMenu.menuItems,
    onNavChange: _ctx.clickEvent
  }, null, 8, ["breadcrumbs", "menuItems", "onNavChange"])) : _createCommentVNode("", true), _ctx.showAvatarSettings || _ctx.$store.state.ShowAvatarSettings ? (_openBlock(), _createBlock(_component_VoiceSelector, {
    key: 4,
    breadcrumbs: _ctx.avatarSettings.breadcrumbs,
    avatarSettings: _ctx.avatarSettings
  }, null, 8, ["breadcrumbs", "avatarSettings"])) : _createCommentVNode("", true), _ctx.showHowToDocs ? (_openBlock(), _createBlock(_component_mainMenuNavigationItem, {
    key: 5,
    breadcrumbs: _ctx.howToDocs.breadcrumbs,
    menuItems: _ctx.howToDocs.menuItems,
    onNavChange: _ctx.clickEvent
  }, null, 8, ["breadcrumbs", "menuItems", "onNavChange"])) : _createCommentVNode("", true), _ctx.showBilling ? (_openBlock(), _createBlock(_component_mainMenuNavigationItem, {
    key: 6,
    breadcrumbs: _ctx.billing.breadcrumbs,
    menuItems: _ctx.billing.menuItems,
    onNavChange: _ctx.clickEvent
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.tokenBalance), 1), _hoisted_13, _ctx.tokenBalanceError ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Token Balance is not current. Please check back later")) : _createCommentVNode("", true), _createElementVNode("button", {
        "class": "button",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          _ctx.$store.commit('updateShowPurchaseTokens', true);
          _ctx.$store.commit('updateShowMainMenu', false);
        })
      }, "Buy More Tokens")]), !_ctx.$store.state.proMembership ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        "class": "button",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.$store.commit('updateShowUpgradeMembershipPage', true);
        })
      }, "Upgrade To Pro Today")) : _createCommentVNode("", true), _hoisted_15, _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.billingCurrentItems, function (purchasedItem, currentItemIndex) {
        return _openBlock(), _createElementBlock("div", {
          "class": "purchases__item",
          key: "currentItems_".concat(currentItemIndex)
        }, [_createElementVNode("div", _hoisted_17, [purchasedItem.itemId === 'clothing' ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
          key: 0,
          "class": "purchases__icon",
          icon: ['fa', 'shirt'],
          style: {
            "--fa-secondary-color": "#478bff"
          }
        })) : (_openBlock(), _createBlock(_component_font_awesome_icon, {
          key: 1,
          "class": "purchases__icon",
          icon: ['fad', 'trophy-star'],
          style: {
            "--fa-secondary-color": "#478bff"
          }
        }))]), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.removeAllUnderScores(purchasedItem.itemId)), 1)]);
      }), 128))]), _hoisted_19, _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.billingAllHistoricalItems, function (purchasedItemHistorical, currentItemIndex) {
        return _openBlock(), _createElementBlock("div", {
          "class": "purchases__item",
          key: "currentItems_".concat(currentItemIndex)
        }, [_createElementVNode("div", _hoisted_21, [purchasedItemHistorical.itemId === 'clothing' ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
          key: 0,
          "class": "purchases__icon",
          icon: ['fa', 'shirt'],
          style: {
            "--fa-secondary-color": "#478bff"
          }
        })) : (_openBlock(), _createBlock(_component_font_awesome_icon, {
          key: 1,
          "class": "purchases__icon",
          icon: ['fa', 'trophy-star'],
          style: {
            "--fa-secondary-color": "#478bff"
          }
        }))]), _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.removeAllUnderScores(purchasedItemHistorical.itemId)), 1)]);
      }), 128))])])];
    }),
    _: 1
  }, 8, ["breadcrumbs", "menuItems", "onNavChange"])) : _createCommentVNode("", true), _ctx.showPoliciesAndTerms ? (_openBlock(), _createBlock(_component_mainMenuNavigationItem, {
    key: 7,
    breadcrumbs: _ctx.policyAndTerms.breadcrumbs,
    menuItems: _ctx.policyAndTerms.menuItems,
    onNavChange: _ctx.clickEvent
  }, null, 8, ["breadcrumbs", "menuItems", "onNavChange"])) : _createCommentVNode("", true), _ctx.showCommunityGuidelines ? (_openBlock(), _createBlock(_component_mainMenuNavigationItem, {
    key: 8,
    breadcrumbs: _ctx.communityGuidelines.breadcrumbs,
    menuItems: _ctx.communityGuidelines.menuItems,
    onNavChange: _ctx.clickEvent
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_communityGuidelines)];
    }),
    _: 1
  }, 8, ["breadcrumbs", "menuItems", "onNavChange"])) : _createCommentVNode("", true), _ctx.showTermsOfService ? (_openBlock(), _createBlock(_component_mainMenuNavigationItem, {
    key: 9,
    breadcrumbs: _ctx.termsOfService.breadcrumbs,
    menuItems: _ctx.termsOfService.menuItems,
    onNavChange: _ctx.clickEvent
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_termsOfService)];
    }),
    _: 1
  }, 8, ["breadcrumbs", "menuItems", "onNavChange"])) : _createCommentVNode("", true), _ctx.showPrivacyPolicy ? (_openBlock(), _createBlock(_component_mainMenuNavigationItem, {
    key: 10,
    breadcrumbs: _ctx.privacyPolicy.breadcrumbs,
    menuItems: _ctx.privacyPolicy.menuItems,
    onNavChange: _ctx.clickEvent
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_privacyPolicy)];
    }),
    _: 1
  }, 8, ["breadcrumbs", "menuItems", "onNavChange"])) : _createCommentVNode("", true), _ctx.showFeedbackSupport ? (_openBlock(), _createBlock(_component_mainMenuNavigationItem, {
    key: 11,
    breadcrumbs: _ctx.feedbackSupport.breadcrumbs,
    menuItems: _ctx.feedbackSupport.menuItems,
    onNavChange: _ctx.clickEvent
  }, {
    "default": _withCtx(function () {
      return [_hoisted_23];
    }),
    _: 1
  }, 8, ["breadcrumbs", "menuItems", "onNavChange"])) : _createCommentVNode("", true), _ctx.showReleaseNotes ? (_openBlock(), _createBlock(_component_mainMenuNavigationItem, {
    key: 12,
    breadcrumbs: _ctx.releaseNotes.breadcrumbs,
    menuItems: _ctx.releaseNotes.menuItems,
    onNavChange: _ctx.clickEvent
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_releaseNotes)];
    }),
    _: 1
  }, 8, ["breadcrumbs", "menuItems", "onNavChange"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}